import { IAppState } from '../../types/reducers/state';
import { selectActiveServiceId } from './selectActiveServiceId';
import { selectIsServicesEnabled } from './selectIsServicesEnabled';

export const selectActiveServiceIdIfEnabled = (state: IAppState) => {
  const isServicesEnabled = selectIsServicesEnabled(state);

  if (!isServicesEnabled) {
    return null;
  }

  return selectActiveServiceId(state);
};
